module.exports = __webpack_public_path__ + "img/life-mobile.5b1e9431.png";